import Client from 'shopify-buy';

import types from '../data/types';

import sizing from './sizing';
import result from '../components/result.vue';

export default {
  mixins: [
    sizing,
  ],
  components: {
    result,
  },
  data(){
    let products = window.localStorage.getItem('products');
    if(products){
      products = JSON.parse(products);
    }
    return {
      types,

      client: null,
      products: products,
      error: null,
    }
  },
  async mounted(){
    try{
      this.client = Client.buildClient({
        domain: 'bosombesties.com',
        storefrontAccessToken: '7245be8af7e21f7363292c0326561587'
      });
      // TODO: handle the eventuality of more than 250 products
      this.products = await this.client.product.fetchAll(50);
      window.localStorage.setItem('products', JSON.stringify(this.products));
    } catch (error) {
      console.error(error);
      this.error = error;
    }
  },
  methods: {
    get_available_products({uk_size = null, shape = null, type = undefined}){
      if(this.products){
        let available_products = this.products;
        if(uk_size){
          available_products = available_products.filter(
            product => this.get_size_variant(product, uk_size)
          );
        }
        if(shape){
          available_products = available_products.filter(
            product => this.includes_tag(product, shape)
          );
        }
        if(type !== undefined){
          if(type){
            available_products = available_products.filter(
              product => this.includes_tag(product, type)
            )
          } else {
            for(let type of Object.values(this.types)){
              if(type){
                available_products = available_products.filter(
                  product => !this.includes_tag(product, type)
                )
              }
            }
          }
        }
        return available_products;
      }
    },
    includes_tag(product, tag){
      return product.tags.find(
        product_tag => product_tag.value === tag
      )
    },
    get_variant(product, value){
      return product.variants.find(
        variant => this.is_valid_variant(variant, value)
      )
    },
    get_size_variant(product, uk_size){
      return product.variants.find(
        variant => this.is_valid_size_variant(variant, uk_size)
      )
    },
    is_valid_variant(variant, value){
      return variant.selectedOptions.find(
        option => option.value === value
      );
    },
    is_valid_size_variant(variant, uk_size){
      if(!variant.available){
        // exclude out of stock
        return false;
      }
      let size_option = variant.selectedOptions.find(
        option => option.name === 'Size'
      );
      if(size_option){
        let us_size = this.us_from_uk(uk_size);
        if(us_size === uk_size){
          if(size_option.value === uk_size){
            return true;
          }
        } else {
          if(size_option.value.includes(`${us_size} US`) && size_option.value.includes(`${uk_size} UK`)){
            return true;
          }
        }

        let size_range_regex = /\((\d+)(-(\d+))?([A-L]+)(-([A-L]+))?\)/;
        let matches = size_range_regex.exec(size_option.value);
        if(matches){
          let min_band = matches[1];
          let max_band = matches[3];
          let min_cup = matches[4];
          let max_cup = matches[6];

          let min_cup_index = this.sorted_uk_cup_sizes.indexOf(min_cup);
          let max_cup_index = max_cup && this.sorted_uk_cup_sizes.indexOf(max_cup);

          let band_size = this.get_band_size(uk_size);
          let uk_cup_size = this.get_cup_size(uk_size);
          let cup_index = this.sorted_uk_cup_sizes.indexOf(uk_cup_size);

          if(parseInt(min_band) <= band_size && band_size <= parseInt(max_band || min_band)){
            if(min_cup_index <= cup_index && cup_index <= (max_cup_index || min_cup_index)){
              return true;
            }
          }
        }
      }
    },
    get_options(option_name){
      let options = [];
      if(this.products){
        for(let product of this.products){
          for(let variant of product.variants){
            let selected_option = variant.selectedOptions.find(selected_option => selected_option.name === option_name);
            if(selected_option){
              if(options.indexOf(selected_option.value) < 0){
                options.push(selected_option.value);
              }
            }
          }
        }
      }
      return options;
    },
    exact_match_has_been_sold(product, underbust_size, cup_size, fit){
      if(this.manual_sizes) {
        let manual_size = this.manual_sizes.find(
          manual_size =>
            parseFloat(manual_size.band_size) === parseFloat(underbust_size)
            && parseFloat(manual_size.cup_size) === parseFloat(cup_size)
        );
        if(manual_size){
          let uk_size = manual_size.uk_sizes.find(uk_size => uk_size.fit === fit);
          if (uk_size){
            let contains = uk_size.confirmed_bras.find(
              confirmed_bra => product.title.includes(confirmed_bra.name)
            );
            if(contains){
              return true;
            }
          }
          let us_size = manual_size.us_sizes.find(us_size => us_size.fit === fit);
          if (us_size){
            let contains = us_size.confirmed_bras.find(
              confirmed_bra => product.title.includes(confirmed_bra.name)
            );
            if(contains){
              return true;
            }
          }
        }
      }
    }
  },
}
